import Vue from 'vue'
import store from '@/store'
import api from '@/api/Api'
import md5 from 'js-md5'
import $ from 'jquery'
import is from './is'
import lists from './lists'
import _ from 'lodash'

export const changeEnv = (env) => {
    store.dispatch('api/changeEnv', {
        env: env
    })
}

export const dateFormat = 'd M Y'
export const dateTimeFormat = 'd M Y, h:i a'

export const initiate = () => {
    store.dispatch('api/isAuthenticated')
}

export const authenticate = (data) => {
    let wait = $.Deferred()
    
    api.post('/authenticate', data).then(
        (r) => {
            setInfo(r.data).then(
                (r) => {
                    return wait.resolve(r).promise()
                },
                (r) => {
                    return wait.reject(api.getError(r)).promise()
                }
            )
        },
        (r) => {
            return wait.reject(api.getError(r)).promise()
        }
    )
    
    return wait.promise()
}

export const account = (data) => {
    let wait = $.Deferred()
    
    api.post('/Member/account', data, false, {}, api.CONTENT_TYPE_BODY).then(
        (r) => {
            return wait.resolve(r.data).promise()
        },
        (r) => {
            return wait.reject(api.getError(r)).promise()
        }
    )
    
    return wait.promise()
}

export const getInfo = () => {
    return store.getters['api/userInfo']
}

export const setInfo = (data) => {
    let wait = $.Deferred()
    
    store.dispatch('api/authenticate', data)
    
    reFetch().then(
        (r) => {
            lists.bootApp().then(
                () => {
                    let redirect = '/campus'
                    
                    if(window.Vue.$route.query.redirect)
                        redirect = '/'+window.Vue.$route.query.redirect.replace(/^\/+/, '')
                    
                    Vue.router.push({
                        path: redirect
                    })
                    
                    return wait.resolve(r).promise()
                },
                (r1) => {
                    return wait.resolve(r1).promise()
                }
            )
        },
        (r) => {
            return wait.reject(r).promise()
        }
    )
    
    return wait.promise()
}

export const redirectToLogin = () => {
    store.dispatch('api/invalidate')
    // do force reload to clear all states
    window.top.location.href = '/'
}

export const isTokenInvalid = (r) => {
    return (
        r.errorType === 'API_ERROR'
            &&
        r.errorCode === 'API_TOKEN_EXPIRED'
    )
}

export const reFetch = () => {
    let wait = $.Deferred()
    
    api.get('/Member/getInfo').then(
        (r) => {
            store.dispatch('api/setUserInfo', r.data)
            return wait.resolve(r).promise()
        },
        (r) => {
            return wait.reject(r).promise()
        }
    )
    
    return wait.promise()
}

export const avatar = () => {
    let u = getInfo()
    
    return u.avatar ?avatarSize(u.avatar) :getAvatar(u.email, is.value('about.gender', u) || 'Male')
}

export const avatarSize = (avatar, size='100') => {
    return avatar.replace('fixed_100-100', 'fixed_'+size+'-'+size)
}

export const getAvatar = (email, gender, size=100) => {
    email = email || 'dummy-email@dummy.com'
    let fallbackUrl = 'https://peeronline-api-dev.gbci.org/images/default/avatar/'+((gender === 'Male') ?'m-' :'w-')+_.random(1, 4)+'.png'
    return ('https://www.gravatar.com/avatar/'+md5(email.toLowerCase())+'?s='+size+'&r=g&d='+encodeURIComponent(fallbackUrl))
}

export const getBillTo = () => {
    let info = getInfo()
    let address = {}
    
    if(info.address) {
        if(info.address.billing)
            address = info.address.billing
        else if(info.address.mailing)
            address = info.address.mailing
        else if(info.address.location)
            address = info.address.location
    }
    
    let obj = {
        firstName: info.firstName+' '+info.lastName,
        lastName: '',
        email: info.email,
        address1: address.address1 || '',
        address2: address.address2 || '',
        city: address.city || '',
        country: address.country || 'US',
        state: address.state || '',
        zipCode: '',
        taxId1: '', // GSTIN:33AAAAA1111A1ZA
        taxExempt: false,
        taxExemptInfo: {}
    }
    
    obj.state = $.trim(obj.state)
    
    return obj
}

export default {
    dateFormat, dateTimeFormat,
    changeEnv,
    initiate,
    authenticate,
    account,
    getInfo,
    setInfo,
    isTokenInvalid,
    reFetch,
    redirectToLogin,
    avatar,
    getAvatar,
    avatarSize,
    getBillTo
}
